<template>
  <div class="md:tw-mx-16 tw-pb-48 md:tw-pb-24 md:tw-pt-4 lg:tw-pt-4">
    <div class="tw-text-left tw-mb-8 tw-mx-4 md:tw-mx-0">
      <RouterLink to="/menu" class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2 hover:tw-text-orange-medium">Menu</RouterLink>
    </div>

    <div class="tw-flex">
      <div class="tw-flex-shrink-0 tw-w-1/5 tw-hidden xl:tw-block">
        <template v-if="viewLoading">
          <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white">
            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
          
            <div class="tw-px-8">
              <SkeletonLoader class="tw-w-1/3 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-2/3 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
            </div>
          </div>
        </template>

        <template v-else>
          <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white">
            <div class="tw-bg-black tw-py-4 tw-px-8 tw-text-white tw-flex tw-cursor-pointer" @click="sidePanelOpen = !sidePanelOpen" v-if="false">
              <h3 class="tw-text-2xl tw-font-black tw-uppercase">Menu</h3> <span :class="['tw-ml-auto fa fa-chevron-right tw-transition', {'tw-rotate-90': sidePanelOpen}]"></span>
            </div>
            <TwCollapse
              :duration="300"
              :collapseOpen="sidePanelOpen">
              <div class="tw-px-16 tw-py-12">
                <CategoryLink
                  class="tw-mb-4 tw-w-full tw-block"
                  v-for="category in getMenu"
                  :key="category.id"
                  :category="category"
                  />
                <div class="tw-mb-4 tw-w-full tw-block">
                  <router-link class="tw-cursor-pointer tw-group tw-w-full tw-block" :to="{ name: 'all-categories'}">
                    <div :class="['tw-uppercase']">
                      All Categories
                    </div>
                  </router-link>
                </div>
              </div>
            </TwCollapse>
          </div>
        </template>
      </div>

      <div class="tw-w-full tw-flex-1 tw-min-w-0 lg:tw-mx-12">  
        <div class="tw-mx-8 md:tw-mx-0" 
          v-if="!viewLoading && userStore.userLocation && userStore.userLocation.id">
          <LocationAlerts :location="(userStore.userLocation! as any) as Location" />
        </div>
        
        <EditOrderAlert
          v-if="showEditingOrderAlert && !viewLoading"
          :cutoffTime="editCutoffTime"
          @cancelEditOrder="cancelEditOrder"
        />

        <template v-if="viewLoading">
          <div class="tw--mx-1 lg:tw--mx-4 xl:tw--mx-1 2xl:tw--mx-4">
            <div 
              class="xl:tw-mx-4 tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white tw-mb-12" >
              <SkeletonLoader class="tw-w-full tw-h-16 tw-mb-8"/>

              <div class="tw-py-8 tw-flex tw-flex-wrap">
                <div v-for="index in 4" 
                  :key="'loader-'+index"
                  :class="['tw-w-full md:tw-w-1/2 xl:tw-w-full 2xl:tw-w-1/4 tw-border-gray-200 tw-flex-shrink-0 tw-px-8 tw-flex tw-flex-col', 
                  'tw-py-8 2xl:tw-py-0 md:tw-my-4 xl:tw-my-0',
                  {'md:tw-border-r-2 xl:tw-border-r-0': ((index % 2 != 0) && (index % 4 != 0))},
                  {'tw-border-l-0 2xl:tw-border-l-2': (index != 1)},
                  {'tw-border-b-2 md:tw-border-b-0 xl:tw-border-b-2 2xl:tw-border-b-0': (index != 4)}]" >
                  <SkeletonLoader class="tw-w-4/5 tw-h-16 tw-mb-8"/>

                  <SkeletonLoader class="tw-w-1/2 tw-h-8 tw-mb-4" />
                  <SkeletonLoader class="tw-w-1/4 tw-h-8 tw-mb-4" />
                  <SkeletonLoader class="tw-w-2/3 tw-h-8 tw-mb-8" />

                  <SkeletonLoader class="tw-w-1/3 tw-h-8 tw-mb-4" />
                  <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />

                  <SkeletonLoader class="tw-w-1/4 tw-h-4 tw-mb-8" />

                  <SkeletonLoader type="circle" class="tw-w-full tw-rounded-full tw-h-16 tw-mb-8" />
                </div>
              </div>
            </div>
          </div>


          <div class="tw--mx-1 lg:tw--mx-4 xl:tw--mx-1 2xl:tw--mx-4">
            <div class="tw-mb-8">
              <div class="tw-rounded-3xl tw-overflow-hidden tw-cursor-pointer tw-shadow-lg tw-bg-white tw-px-16 tw-py-16 xl:tw-mx-4">
                <SkeletonLoader class="tw-w-1/3 tw-h-16 tw-mb-8" />
                <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
                <SkeletonLoader class="tw-w-1/2 tw-h-8 tw-mb-4" />
              </div>
            </div>
            <template v-if="suggestedOrdersOpen">
              <div class="tw-flex tw-flex-wrap tw-pb-16 tw-pt-8 md:tw-px-1">
                <div 
                  class="tw-flex md:tw-my-1 md:tw-px-1 tw-w-full md:tw-w-1/2 md:tw-pb-8 xl:tw-pb-8 xl:tw-px-4 xl:tw-w-1/3 tw-border-b tw-border-gray-500 md:tw-border-b-0" 
                  v-for="idx in 3" 
                  :key="'loader-'+idx">
                  <div class="tw-overflow-hidden tw-rounded-3xl tw-shadow-lg tw-bg-white tw-block tw-cursor-pointer tw-group tw-w-full tw-block">
                    <div class="tw-overflow-hidden tw-block tw-h-auto tw-w-full">
                      <SkeletonLoader class="tw-w-full tw-h-96" />
                    </div>
                    <div class="tw-mx-12 tw-mt-8 tw-pb-8">
                      <SkeletonLoader class="tw-w-full tw-h-12" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="tw-mb-8">
              <div class="tw-rounded-3xl tw-overflow-hidden tw-cursor-pointer tw-shadow-lg tw-bg-white tw-px-16 tw-py-16 xl:tw-mx-4">
                <SkeletonLoader class="tw-w-1/3 tw-h-16 tw-mb-8" />
                <SkeletonLoader class="tw-w-1/4 tw-h-8 tw-mb-4" />
              </div>
            </div>
            <template v-if="menuOpen">
              <div class="tw-flex tw-flex-wrap">
                <div 
                  class="tw-flex md:tw-my-1 md:tw-px-1 tw-w-full md:tw-w-1/2 md:tw-pb-8 xl:tw-pb-8 xl:tw-px-4 xl:tw-w-1/3 tw-border-b tw-border-gray-500 md:tw-border-b-0" 
                  v-for="idx in 12" 
                  :key="'loader-'+idx">
                  <div class="tw-overflow-hidden tw-rounded-3xl tw-shadow-lg tw-bg-white tw-block tw-cursor-pointer tw-group tw-w-full tw-block">
                    <div class="tw-overflow-hidden tw-block tw-h-auto tw-w-full">
                      <SkeletonLoader class="tw-w-full tw-h-96" />
                    </div>
                    <div class="tw-mx-12 tw-mt-8 tw-pb-8">
                      <SkeletonLoader class="tw-w-full tw-h-12" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>

        <template v-else>
          <div class="tw--mx-1 lg:tw--mx-4 xl:tw--mx-1 2xl:tw--mx-4">
            <div 
              class="xl:tw-mx-4 tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white tw-mb-12" 
              v-if="userStore.upcomingOrders != null && userStore.upcomingOrders.length > 0">
              <div class="tw-bg-black tw-py-4 tw-px-8 tw-text-white" @click="toggleUpcomingOrdersCollapse">
                <div class="tw-relative tw-pr-24">
                  <h3 class="tw-text-2xl tw-font-black tw-uppercase tw-inline-block">Upcoming Catering Orders</h3>
                  <span class="tw-italic tw-transition-all tw-duration-300 tw-text-xxl tw-pl-6">{{ upcomingOrdersOpen ? 'Click to hide' : 'Click to expand' }}</span>
                  <span :class="['tw-absolute tw-top-1/2 tw--translate-y-1/2 tw-right-0 fa fa-chevron-right tw-transition tw-inline-block tw-origin-center tw-text-3xl', {'tw-rotate-90': upcomingOrdersOpen}]"></span>
                </div>
              </div>
              <TwCollapse
                :duration="300"
                :collapseOpen="upcomingOrdersOpen">
                <div class="tw-py-8 tw-flex tw-flex-wrap">
                  <PreviousOrder
                    :class="['tw-w-full md:tw-w-1/2 xl:tw-w-full 2xl:tw-w-1/4 tw-border-gray-500 tw-flex-shrink-0 tw-px-8 tw-flex tw-flex-col', 
                    'tw-py-8 2xl:tw-py-0 md:tw-my-4 xl:tw-my-0',
                    {'2xl:tw-mt-8': (index > 3)},
                    {'md:tw-border-r-2 xl:tw-border-r-0': ((index + 1) % 2 != 0 && (index + 1 % 4 != 0))},
                    {'tw-border-l-0 2xl:tw-border-l-2': (index != 0) && (index % 4 != 0)},
                    {'tw-border-b-2 md:tw-border-b-0 xl:tw-border-b-2 2xl:tw-border-b-0': index != userStore.upcomingOrders.length - 1}]" 
                    v-for="(order, index) in userStore.upcomingOrders" 
                    :key="'order'+index"
                    :index="index"
                    :reordering="addingRecentOrder != null && addingRecentOrder.id == order.id"
                    :editable="order.editable && showEditingOrderAlert != true"
                    :disabled="addingRecentOrder != null"
                    :currentlyEditing="(cateringOrderStore.cateringOrder != null && cateringOrderStore.cateringOrder.source_order_id != null && cateringOrderStore.cateringOrder.source_order_id == order.catering_order.id) ? true : false"
                    @handleRecentOrderModal="popRecentOrderModal(order)"
                    @handleRecentOrderClick="popRecentOrderModal"
                    @handleEditOrderClick="popRecentOrderModal"
                    @handleCancelOrderClick="popRecentOrderModal"
                    :locations="locationStore.locations"
                    :carousel="false"
                    :order="order" />
                </div>
              </TwCollapse>
            </div>
            <div 
              class="xl:tw-mx-4 tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white tw-mb-12" 
              v-if="userStore.orders != null && userStore.orders.length > 0">
              <div class="tw-bg-black tw-py-4 tw-px-8 tw-text-white" @click="togglePreviousOrdersCollapse">
                <div class="tw-relative tw-pr-24">
                  <h3 class="tw-text-2xl tw-font-black tw-uppercase tw-inline-block">Previous Catering Orders</h3>
                  <span class="tw-italic tw-transition-all tw-duration-300 tw-text-xxl tw-pl-6">{{ previousOrdersOpen ? 'Click to hide' : 'Click to expand' }}</span>
                  <span :class="['tw-absolute tw-top-1/2 tw--translate-y-1/2 tw-right-0 fa fa-chevron-right tw-transition tw-inline-block tw-origin-center tw-text-3xl', {'tw-rotate-90': previousOrdersOpen}]"></span>
                </div>
              </div>
              <TwCollapse
                :duration="300"
                :collapseOpen="previousOrdersOpen">
                <div class="tw-py-8 tw-flex tw-flex-wrap">
                  <PreviousOrder
                    :class="['tw-w-full md:tw-w-1/2 xl:tw-w-full 2xl:tw-w-1/4 tw-border-gray-500 tw-flex-shrink-0 tw-px-8 tw-flex tw-flex-col', 
                    'tw-py-8 2xl:tw-py-0 md:tw-my-4 xl:tw-my-0',
                    {'md:tw-border-r-2 xl:tw-border-r-0': ((index + 1) % 2 != 0 && (index + 1 % 4 != 0))},
                    {'tw-border-l-0 2xl:tw-border-l-2': (index != 0)},
                    {'tw-border-b-2 md:tw-border-b-0 xl:tw-border-b-2 2xl:tw-border-b-0': index != userStore.orders.length - 1}]" 
                    v-for="(order, index) in userStore.orders" 
                    :key="'order'+index"
                    :index="index"
                    :reordering="addingRecentOrder != null && addingRecentOrder.id == order.id"
                    :editable="false"
                    :disabled="addingRecentOrder != null"
                    :currentlyEditing="false"
                    @handleRecentOrderModal="popRecentOrderModal"
                    @handleRecentOrderClick="popRecentOrderModal"
                    @handleEditOrderClick="popRecentOrderModal"
                    @handleCancelOrderClick="popRecentOrderModal"
                    :carousel="false"
                    :locations="locationStore.locations"
                    :order="order" />
                </div>
              </TwCollapse>
            </div>

            <template v-if="cateringOrderStore!.cateringOrder!.guest_count > 0 && cateringOrderStore!.suggestions && cateringOrderStore!.suggestions.length > 0">
              <div class="tw-mb-8">
                <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white xl:tw-mx-4">
                  <div class="tw-relative tw-pr-24 tw-px-16 tw-pb-12 tw-pt-8 tw-cursor-pointer" @click="toggleSuggestionsCollapse">
                    <h2 class="tw-font-black tw-text-2xl sm:tw-text-3xl md:tw-text-4xl lg:tw-text-4xl xl:tw-text-4xl 2xl:tw-text-5xl tw-leading-tight tw-text-black tw-whitespace-nowrap md:tw-inline-block md:tw-bg-orange-medium md:tw-text-white md:tw-py-6 md:tw-pr-20 md:tw--ml-16 md:tw-px-16 md:tw-rounded-r-full md:tw-rounded-l-none">
                      PACKS CURATED FOR YOU
                    </h2>
                    <span :class="['tw-absolute tw-top-1/2 tw--translate-y-1/2 tw-right-16 fa fa-chevron-right tw-transition tw-inline-block tw-origin-center tw-text-3xl hover:tw-text-orange-medium', {'tw-rotate-90': suggestedOrdersOpen}]"></span>
                  </div>

                  <TwCollapse :duration="300" :collapseOpen="suggestedOrdersOpen">
                    <div class="tw-w-full tw-max-w-full tw-overflow-hidden tw-box-border tw-mb-10">
                      <div class="tw-bg-white tw-w-full">
                        <Carousel
                          :key="suggestionsCarouselKey"
                           :items-to-show="1"
                           :wrap-around="true"
                           :mouse-drag="false"
                           class="tw-w-full tw-px-4 carousel"
                        >
                          <Slide
                            v-for="(suggestion, index) in cateringOrderStore.suggestions"
                            :key="suggestion.id ?? index"
                          >
                            <div class="tw-flex tw-w-full tw-justify-center tw-items-center tw-px-4 md:tw-px-8">
                              <SuggestedOrder
                                class="tw-w-full sm:tw-pl-2"
                                :suggestion="suggestion"
                                :isLoading="addingSuggestion == index"
                                :isDisabled="addingSuggestion > -1"
                                :index="index"
                                @handleSuggestedOrderClick="popSuggestionNoticeModal"
                                @handleSuggestedOrderModal="popSuggestionModal"
                              />
                            </div>
                          </Slide>

                          <template #addons>
                            <Navigation />
                            <Pagination />
                          </template>
                        </Carousel>
                      </div>
                    </div>
                  </TwCollapse>
                </div>
              </div>
            </template>

            <template v-else-if="!suggestedOrdersLoaded">
              <div class="tw-mb-8">
                <div 
                  class="tw-rounded-3xl tw-overflow-hidden tw-cursor-pointer tw-shadow-lg tw-bg-white tw-px-16 tw-py-16 xl:tw-mx-4 hover:tw-text-orange-medium" 
                  @click="toggleSuggestionsCollapse">
                  <div class="tw-relative tw-pr-24">
                    <h2 class="tw-text-6xl tw-font-black tw-mr-auto tw-transition-all tw-duration-300">
                      Need Some Suggestions?
                    </h2>
                    <p class="tw-text-3xl tw-italic tw-pt-4 tw-mb-0 lg:tw-w-3/4 tw-transition-all tw-duration-300">These orders have been curated specifically for you and are a complete, one-click package to get you everything you need for your catering order.</p>
                    <span :class="['tw-absolute tw-top-1/2 tw--translate-y-1/2 tw-right-0 fa fa-chevron-right tw-transition tw-inline-block tw-origin-center tw-text-3xl', {'tw-rotate-90': suggestedOrdersOpen}]"></span>
                  </div>
                </div>
              </div>
              <template v-if="suggestedOrdersOpen">
                <div class="tw-flex tw-flex-wrap">
                  <div 
                    class="tw-flex md:tw-my-1 md:tw-px-1 tw-w-full md:tw-w-1/2 md:tw-pb-8 xl:tw-pb-8 xl:tw-px-4 xl:tw-w-1/3 tw-border-b tw-border-gray-500 md:tw-border-b-0" 
                    v-for="idx in 3" 
                    :key="'loader-'+idx">
                    <div class="tw-overflow-hidden tw-rounded-3xl tw-shadow-lg tw-bg-white tw-block tw-cursor-pointer tw-group tw-w-full tw-block">
                      <div class="tw-overflow-hidden tw-block tw-h-auto tw-w-full">
                        <SkeletonLoader class="tw-w-full tw-h-96" />
                      </div>
                      <div class="tw-mx-12 tw-mt-8 tw-pb-8">
                        <SkeletonLoader class="tw-w-full tw-h-12" />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>

            <template v-else-if="cateringOrderStore!.cateringOrder != null && cateringOrderStore!.cateringOrder!.guest_count == 0">
              <div class="tw-mb-8">
                <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white tw-px-16 tw-py-16 xl:tw-mx-4">
                  <div class="tw-relative tw-pr-24">
                    <h2 class="tw-text-6xl tw-font-black tw-mr-auto tw-transition-all tw-duration-300">
                      Need Some Suggestions?
                    </h2>
                    <p class="tw-text-3xl tw-italic tw-pt-4 tw-mb-0 lg:tw-w-3/4 tw-transition-all tw-duration-300">
                      Looking for inspiration? Go back and edit your Guest count so we can accurately suggest packs, currated just for you!
                    </p>
                  </div>
                </div>
              </div>
            </template>

            <div class="tw-mb-12">
              <div 
                class="tw-mb-8 tw-rounded-3xl tw-overflow-hidden tw-cursor-pointer tw-shadow-lg tw-bg-white tw-px-16 tw-py-16 xl:tw-mx-4 hover:tw-text-orange-medium" 
                @click="menuOpen = !menuOpen">
                <div class="tw-relative tw-pr-24">
                  <h2 class="tw-text-6xl tw-font-black tw-mr-auto tw-transition-all tw-duration-300">
                    Menu
                  </h2>
                  <div class="tw-italic tw-transition-all tw-duration-300 tw-pt-4 ">
                    {{ menuOpen ? 'Click to hide' : 'Click to expand'}}
                  </div>
                  <span :class="['tw-absolute tw-top-1/2 tw--translate-y-1/2 tw-right-0 fa fa-chevron-right tw-transition tw-inline-block tw-origin-center tw-text-3xl', {'tw-rotate-90': menuOpen}]"></span>
                </div>
              </div>
              <TwCollapse
                :duration="500"
                :collapseOpen="menuOpen">
                  <div class="tw-flex tw-flex-wrap">
                    <Category
                      class="tw-flex md:tw-my-1 md:tw-px-1 tw-w-full md:tw-w-1/2 md:tw-pb-8 xl:tw-pb-8 xl:tw-px-4 xl:tw-w-1/3 tw-border-b tw-border-gray-500 md:tw-border-b-0"
                      v-for="category in getMenu"
                      :key="category.id"
                      :category="category"
                     />
                  </div>
              </TwCollapse>
            </div>
          </div>
        </template>
      </div>

      <div class="tw-flex-shrink-0 xl:tw-w-1/5 lg:tw-w-1/4 tw-hidden lg:tw-block">
        <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white tw-mb-16">
          <template v-if="viewLoading">
            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
          
            <div class="tw-px-8">
            <SkeletonLoader class="tw-w-1/3 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-2/3 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
            </div>

            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
            <div class="tw-px-8">
            <SkeletonLoader class="tw-w-2/3 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-2/3 tw-h-8 tw-mb-8" />
            </div>

            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
            <div class="tw-px-8">
              <SkeletonLoader class="tw-w-1/3 tw-h-8 tw-mb-4" />
              <SkeletonLoader class="tw-w-full tw-h-4 tw-mb-8" />
            </div>
            
            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
            <div class="tw-px-8">
              <SkeletonLoader class="tw-w-full tw-h-24 tw-mb-8" />
              <SkeletonLoader class="tw-w-full tw-h-24 tw-mb-8" />
            </div>

            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
            <div class="tw-px-8">
              <SkeletonLoader class="tw-w-full tw-h-4 tw-mb-8" />
              <SkeletonLoader class="tw-w-full tw-h-4 tw-mb-8" />
              <SkeletonLoader class="tw-w-full tw-h-4 tw-mb-8" />
              <SkeletonLoader class="tw-w-full tw-h-4 tw-mb-8" />
            </div>
          </template>

          <template v-else>
            <OrderDetails 
              @basketNutritionDataChanged="nutritionDataChanged"
            />
            <Bag />
            <div class="tw-border-black tw-border-t tw-border-black tw-pt-8 tw-px-8" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
              <BagTotals />
            </div>
            <div class="tw-text-center tw-mt-16" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
              <template v-if="cateringOrderHasNutrition && !cateringOrderNutritionFulfilled">
                <div
                  class="tw-block tw-w-full tw-cursor-pointer tw-bg-orange-medium tw-text-white hover:tw-bg-orange-dark hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200" 
                  @click="popNutritionModal">
                  Review Bag
                </div>
              </template>
              <template v-else>
                <router-link
                  :to="{ name: 'review-bag'}"
                  class="tw-block tw-w-full tw-bg-orange-medium tw-text-white hover:tw-bg-orange-dark hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200" 
                  >
                  Review Bag
                </router-link>
              </template>
            </div>
          </template>
        </div>

        <TwCateringHelp />
      </div>
    </div>

    <TwModal
      v-show="modalSuggestionOpen"
      :hasAccept="true"
      :hasHeader="false"
      @emitClose="closeSuggestionModal">

      <template v-slot:body>
        <template v-if="suggestedOrderModalItem != null">
          <div class="tw-relative tw-pr-24 tw-w-full">
            <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">{{suggestedOrderModalItem.title}}</h2>
            <h2 class="tw-mx-8 tw-font-bold tw-text-4xl tw-block lg:tw-hidden tw-mb-4">${{ suggestedOrderModalItem.cost!.toLocaleString("en-US", {minimumFractionDigits: 2}) }}</h2>

             <button
                type="button"
                class="tw-text-5xl tw-absolute tw-right-2 tw-top-0 hover:tw-text-orange-medium tw-transition-all tw-duration-300"
                @click="closeSuggestionModal"
              >
                &times;
              </button>
          </div>

          <p class="tw-mx-8 tw-mb-8 tw-text-3xl !tw-leading-relaxed">
            <template v-if="modalSuggestionNotice">
              This suggested order may not contain the necessary dietary requirements
              or avoid the allergens you selected.
              You may have to add additional items to your basket to meet your order's needs.
            </template>
            <template v-else>
              {{suggestedOrderModalItem.description}}
            </template>
          </p>
        </template>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8 lg:tw-mb-4" v-if="suggestedOrderModalItem != null">
          <TwButton 
            cssClass="tw-border-2 tw-border-gray-400 tw-text-gray-400 hover:tw-bg-orange-medium hover:tw-border-orange-medium hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-mr-8 tw-rounded-full"
            @emit-click="closeSuggestionModal" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="modalSuggestionNotice ? 'Nevermind' : 'Close'"/>

          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full tw-inline-block lg:tw-hidden"
            @emit-click="handleSuggestionModalAddClick" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Add to Bag'"/>

          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full tw-hidden lg:tw-inline-block"
            @emit-click="handleSuggestionModalAddClick" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="modalAddToBagText"/>
        </div>
      </template>
    </TwModal>

    <TwModal
      v-show="modalNutritionOpen"
      :hasAccept="true"
      :hasHeader="false"
      @emitClose="closeNutritionModal">

      <template v-slot:body>
        <div class="tw-relative tw-pr-24 tw-w-full">
          <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">Your order may not be complete!</h2>
        </div>

        <p class="tw-mx-8 tw-mb-8 tw-text-3xl !tw-leading-relaxed">
          Your order does not meet all the dietary and allergen requirements you specified. Please consider adding more items to fulfill your nutritional needs.
        </p>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8 lg:tw-mb-4">
          <TwButton 
            cssClass="tw-border-2 tw-bg-orange-medium tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-mr-8 tw-rounded-full"
            @emit-click="closeNutritionModal" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Add more items'"/>

          <router-link
            :to="{ name: 'review-bag'}"
            class="tw-bg-white tw-border-2 tw-border-gray-400 tw-text-gray-400 hover:tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full tw-inline-block">
            Continue to Review Bag
          </router-link>
        </div>
      </template>
    </TwModal>

    <TwModal
      v-show="modalRecentOrderOpen"
      :hasAccept="true"
      :hasHeader="false"
      :modalSize="'large'"
      @emitClose="closeRecentOrderModal">

      <template v-slot:body>
        <div class="tw-relative tw-pr-24 tw-w-full">
          <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">Recent Order</h2>
          <button
            type="button"
            class="tw-text-5xl tw-absolute tw-right-2 tw-top-0 hover:tw-text-orange-medium tw-transition-all tw-duration-300"
            @click="closeRecentOrderModal"
          >
            &times;
          </button>
        </div>

        <div v-if="typeof(recentOrderModalItem) != undefined" class="tw-pb-12">
          <PreviousOrderModalContent 
            :order="recentOrderModalItem!"
            :locations="locationStore.locations"
            :loading="loading"
            :editingOrder="cateringOrderStore.cateringOrder != null && cateringOrderStore.cateringOrder.source_order_id != null ? cateringOrderStore.cateringOrder.source_order_id : -1"
            @handleReorderRecentOrderClick="reorderRecentOrder"
            @handleCancelOrderClick="cancelRecentOrder"
            @handleEditOrderClick="editRecentOrder"
          />
        </div>
      </template>
    </TwModal>

    <TwModal
      v-show="modalEditUnderstandOpen"
      :hasAccept="true"
      :hasHeader="false"
      @emitClose="closeEditUnderstandModal">

      <template v-slot:body>
        <div class="tw-relative tw-pr-24 tw-w-full">
          <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">You are editing an order!</h2>
        </div>

        <p class="tw-mx-8 tw-mb-8 tw-text-3xl !tw-leading-relaxed">
          You are now editing an upcoming order. You must place this new order or the original order will still be prepared and charged.
        </p>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8 lg:tw-mb-4">
          <TwButton 
            cssClass="tw-border-2 tw-bg-orange-medium tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-mr-8 tw-rounded-full"
            @emit-click="closeEditUnderstandModal"
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'I understand'"/>
        </div>
      </template>
    </TwModal>
  </div>
</template>

<style scoped>
.carousel {
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  /* theme vars */
  --vc-nav-background: transparent;
  --vc-nav-color: black;
  --vc-nav-color-hover: gray;
  --vc-nav-border-radius: 50%;
  --vc-nav-width: 40px;
  --vc-nav-height: 80px;
  --vc-pgn-background-color: lightgray;
  --vc-pgn-active-color: #F48024;
  --vc-pgn-border-radius: 15px;
  --vc-pgn-height: 15px;
  --vc-pgn-width: 15px;

  /* how much to raise the arrows by (≈ half the H2 block height) */
  --header-offset: 48px;
}

/* Raise the nav arrows relative to the header height */
.carousel :global(.carousel__prev),
.carousel :global(.carousel__next) {
  top: calc(50% - var(--header-offset));
}

/* Optional: tweak for larger screens if the H2 is taller */
@media (min-width: 1024px) {
  .carousel {
    --header-offset: 64px;
  }
}

.carousel :global(.carousel__track) {
  align-items: flex-start;
}


</style>

<script setup lang="ts">
  import {
    reactive, computed, onBeforeMount, onMounted, ref
  } from 'vue';
  import { useRouter } from 'vue-router';

  // Data
  import { useBasketStore } from '../../stores/basket';
  import { useCateringOrderStore } from '../../stores/catering_order';
  import { useMenuStore } from '../../stores/menu';
  import { useLocationsStore } from '../../stores/locations';
  import { useUserStore } from '../../stores/user';
  import { useFlashMessageStore } from '../../stores/flashMessages';


  import type Basket from '../../classes/Basket';
  import type Location from '../../classes/Location';
  import type Product from '../../classes/Product';
  import type CateringOrderSuggestion from '../../classes/CateringOrderSuggestion';
  import type OrderDetail from '../../classes/OrderDetails';
  import type FlashMessage from '../../types/FlashMessage';
  import type OrderProduct from '../../types/OrderProduct';

  // Components
  import SkeletonLoader from '../../components/SkeletonLoader.vue';
  import Category from './_MenuCategory.vue';
  import SuggestedOrder from './_SuggestedOrder.vue';
  import OrderDetails from '../bag/_OrderDetails.vue';
  import Bag from '../bag/_Bag.vue';
  import BagTotals from '../bag/_BagTotals.vue';
  import CategoryLink from './_CategoryLink.vue';
  import TwCollapse from '../../components/TwCollapse.vue';
  import TwCateringHelp from '../../components/TwCateringHelp.vue';
  import LocationAlerts from '../../components/LocationAlerts.vue';
  import EditOrderAlert from '../../components/EditOrderAlert.vue';
  import TwModal from '../../components/TwModal.vue';
  import TwButton from '../../components/TwButton.vue';
  import PreviousOrder from './_PreviousOrder.vue';
  import PreviousOrderModalContent from './_PreviousOrderModalContent.vue';

  import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
  import 'vue3-carousel/dist/carousel.css';

  const router = useRouter();

  const basketStore = useBasketStore();
  const cateringOrderStore = useCateringOrderStore();
  const menuStore = useMenuStore();  
  const locationStore = useLocationsStore();
  const userStore = useUserStore();
  const flashMessageStore = useFlashMessageStore();

  const sidePanelOpen = ref(true);
  const suggestedOrdersLoaded = ref(false);
  const suggestedOrders = ref([] as CateringOrderSuggestion[]);
  const addingSuggestion = ref(-1);
  const suggestedOrdersOpen = ref(false);
  const menuOpen = ref(true);
  const previousOrdersOpen = ref(false);
  const upcomingOrdersOpen = ref(true);
  const suggestionsCarouselKey = computed(() =>
    `suggestions-${suggestedOrdersOpen.value}-${cateringOrderStore.suggestions?.length ?? 0}`
  );
  const modalSuggestion = ref(-1);
  const modalSuggestionOpen = ref(false);
  const modalSuggestionNotice = ref(false);

  const modalEditUnderstandOpen = ref(false);
  
  const modalRecentOrder = ref<OrderDetail | null>(null);
  const modalRecentOrderOpen = ref(false);
  const addingRecentOrder = ref<OrderDetail | null>(null);
  const loading = ref(false);

  const modalNutritionOpen = ref(false);
  const cateringOrderNutritionFulfilled = ref(false);

  const getMenu = computed(() => {
    return menuStore.getFilteredMenu;
  });

  const viewLoading = computed(() => {
    let basketLoaded = false;
    let menuLoaded = false;
    let imagesLoaded = true;
    let recentOrdersLoaded = false

    if (localStorage.getItem('mypiadaBasketId')) {
      if (basketStore.basket && basketStore.basket.id) {
        basketLoaded = true;
      }
    } else {
      basketLoaded = true;
    }

    if (userStore.user == null || userStore.orders != null) {
      recentOrdersLoaded = true;
    }

    if (getMenu.value && getMenu.value.length > 0) {
      menuLoaded = true;
    }

    return (!basketLoaded || !menuLoaded || !imagesLoaded || !recentOrdersLoaded);
  })

  onBeforeMount(() => {
    if (cateringOrderStore.cateringOrder && typeof(cateringOrderStore.cateringOrder.assistance_level) != undefined) {
      let assistanceLvl = cateringOrderStore.cateringOrder.assistance_level;
      let suggestionsUserPreference = localStorage.getItem('suggestionsCollapseOpen');
      if (suggestionsUserPreference) {
        suggestedOrdersOpen.value = (suggestionsUserPreference == 'true');
      } else if (assistanceLvl >= 3) {
        suggestedOrdersOpen.value = true;
      }
      
      if (assistanceLvl >= 5) {
        menuOpen.value = false;
      }

      if ((cateringOrderStore.suggestions == null || cateringOrderStore.suggestions.length == 0) && cateringOrderStore.cateringOrder.guest_count > 0) {
        cateringOrderStore.fetchCateringOrderSuggestion().then(() => {
          suggestedOrdersLoaded.value = true;
        }).catch(() => {
          suggestedOrdersLoaded.value = true;
        });
      } else {
        suggestedOrdersLoaded.value = true;
      }
    }

    upcomingOrdersOpen.value = !basketStore.editing;
  })

  onMounted(() => {
    if (userStore.userLocation != null && cateringOrderStore.cateringOrder) {
      menuStore.fetchMenu(parseFloat(userStore.userLocation.extref));

    } else {
      router.push('wizard'); // User doesn't have a location set so force them to pick one;
    }

    if (userStore.user) {
      // if (userStore.orders == null) {
        userStore.fetchRecentOrders(4).catch(() => {
          // Do nothing
        });
      // }
    }

    if (basketStore.editing && !basketStore.hasAcknowledgedEditing) {
      modalEditUnderstandOpen.value = true;
    }
  })

  const toggleSuggestionsCollapse = (() => {
    suggestedOrdersOpen.value = !suggestedOrdersOpen.value;
    localStorage.setItem('suggestionsCollapseOpen', suggestedOrdersOpen.value.toString());
  })

  const togglePreviousOrdersCollapse = (() => {
    previousOrdersOpen.value = !previousOrdersOpen.value;
    localStorage.setItem('previousOrdersCollapseOpen', previousOrdersOpen.value.toString());
  })

  const toggleUpcomingOrdersCollapse = (() => {
    upcomingOrdersOpen.value = !upcomingOrdersOpen.value;
    localStorage.setItem('upcomingOrdersCollapseOpen', upcomingOrdersOpen.value.toString());
  })

  // Will return a promise of the product add so that it can be handled in the async caller
  const addProduct = ((product: Product, trackSuggestion?: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      let opts = [] as number[];

      if (product.options && product.options.length > 0) {
        opts = product.options;
      } 

      basketStore.addProduct(product.id, product.quantity, "", opts, [], trackSuggestion).then(() => {
        resolve('');
      }).catch((error: Error) => {
        reject(error);
      })
    })
  })

  // Send off multiple add product calls using await so that the basket can't get out of sync
  const addSuggestionToBag = (idx: number) => {

    return new Promise((resolve, reject) => {
      addingSuggestion.value = idx;
      let errors = [] as Error[];

      if (cateringOrderStore.suggestions && cateringOrderStore.suggestions![idx] && cateringOrderStore.suggestions![idx].products) {
        let orderProducts = [] as OrderProduct[];
        for (const product of cateringOrderStore.suggestions![idx].products!) {

          let prod: OrderProduct = {
            id: product.id,
            productid: product.id,
            quantity: product.quantity,
            specialInstructions: '',
            options: product.options,
          };

          orderProducts.push(prod);
        }

        basketStore.addMultipleProducts(orderProducts, cateringOrderStore.suggestions![idx].id).then((basket: Basket) => {
          addingSuggestion.value = -1; 

          if (basket.message && basket.message.length > 0) {
            const message = {
              id: Math.round(Math.random() * 10000000),
              messageType: "danger",
              text: basket.message,
              headline: '',
              delay: 0, // ms
              icon: "",
              cssClass: "",
            } as FlashMessage;
            flashMessageStore.addMessage(message);
          } else {
            const message = {
              id: Math.round(Math.random() * 10000000),
              messageType: "success",
              text: "Products have been added to bag",
              headline: "",
              delay: 5000, // ms
              icon: "",
              cssClass: "",
            } as FlashMessage;
            flashMessageStore.addMessage(message);
          }

          resolve('');
        }).catch((error: Error) => {
          addingSuggestion.value = -1; 
          reject(error);
        })
      }
    });
  }

  const popSuggestionModal = (idx: number) => {
    if (cateringOrderStore.suggestions && cateringOrderStore.suggestions![idx]) {
      modalSuggestion.value = idx;
      modalSuggestionOpen.value = true;
    }
  }

  const addSuggestionFromModal = (() => {
     addSuggestionToBag(modalSuggestion.value);
     closeSuggestionModal();
  })

  const closeSuggestionModal = (() => {
    modalSuggestionOpen.value = false;
    window.setTimeout(function() {
      // Give the modal time to close before erasing the values
      modalSuggestion.value = -1;
      modalSuggestionNotice.value = false;
    }, 500);
  })

  const suggestedOrderModalItem = computed(() => { 
    if (modalSuggestion.value > -1 && cateringOrderStore.suggestions && cateringOrderStore.suggestions![modalSuggestion.value]) {
      return (cateringOrderStore.suggestions![modalSuggestion.value]);
    } else {
      return null;
    }
  })

  const modalAddToBagText = computed(() => {
    let str = 'Add to Bag - $';
    if (suggestedOrderModalItem.value) {
      str += suggestedOrderModalItem.value.cost!.toLocaleString("en-US", {minimumFractionDigits: 2})
    } else {
      str += '0.00'
    }

    return str;
  })

  const cancelEditOrder = () => {
    basketStore.cancelEditOrder().then(() => {
      router.push('wizard');
    })
  }

  const popNutritionModal = () => {
    modalNutritionOpen.value = true;
  }

  const closeNutritionModal = () => {
    modalNutritionOpen.value = false;
  }

  const popSuggestionNoticeModal = (idx: number) => {
    if (cateringOrderStore.suggestions && cateringOrderStore.suggestions![idx]) {
      modalSuggestion.value = idx;

      if (cateringOrderHasNutrition.value) {
          modalSuggestionOpen.value = true;
          modalSuggestionNotice.value = true;
      } else {
        addSuggestionFromModal()
      }
    }
  }

  const cateringOrderHasNutrition = computed(() => {
    if (cateringOrderStore.cateringOrder == null || cateringOrderStore.cateringOrder.allergens == null || cateringOrderStore.cateringOrder.diets == null) {
      return false;
    } else {
      return cateringOrderStore!.cateringOrder!.allergens!.length > 0 || cateringOrderStore!.cateringOrder!.diets!.length > 0
    }
  })

  const nutritionDataChanged = (fulfilled: boolean) => {
    cateringOrderNutritionFulfilled.value = fulfilled;
  }

  const handleSuggestionModalAddClick = () => {
    // if it's the notice modal, add to bag, otherwise, pop the notice modal
    if (modalSuggestionNotice.value) {
      addSuggestionFromModal()
    } else {
      popSuggestionNoticeModal(modalSuggestion.value)
    }
  }

  const closeRecentOrderModal = () => {
    modalRecentOrderOpen.value = false;
    window.setTimeout(function() {
      modalRecentOrder.value = null;
    }, 500);
  }

  const popRecentOrderModal = (order: OrderDetail) => {
    if (order) {
      modalRecentOrder.value = order;
      modalRecentOrderOpen.value = true;
    }
  }

  const closeEditUnderstandModal = () => {
    basketStore.hasAcknowledgedEditing = true;
    modalEditUnderstandOpen.value = false;
  }

  const recentOrderModalItem = computed(() => { 
    if (modalRecentOrder.value != null && modalRecentOrder.value != undefined) {
      return (modalRecentOrder.value);
    } else {
      return null;
    }
  })

  const reorderRecentOrder = ((order: OrderDetail) => {
    addingRecentOrder.value = order;
    loading.value = true;
    if (order.id) {
      basketStore.reorder(order.id).then(() => {
        addingRecentOrder.value = null;
        loading.value = false;
        closeRecentOrderModal();
        if (cateringOrderStore.cateringOrder != null && cateringOrderStore.cateringOrder.time_wanted != null) {
          const message = {
            id: Math.round(Math.random() * 10000000),
            messageType: "success",
            text: "Your order is ready to place! Head to checkout or make any changes you need first",
            headline: "",
            delay: 5000, // ms
            icon: "",
            cssClass: "",
          } as FlashMessage;
          flashMessageStore.addMessage(message);
        } else {
          const message = {
            id: Math.round(Math.random() * 10000000),
            messageType: "success",
            text: "Please select a time before continuing with your order",
            headline: "Re-Order Time",
            delay: 5000, // ms
            icon: "",
            cssClass: "",
          } as FlashMessage;
          flashMessageStore.addMessage(message);
          // Force user to set time wanted
          router.push('/wizard/4');
        }
      }).catch((error) => {
        closeRecentOrderModal();
        if (error.response && error.response.data && error.response.data.message) {
          const message = {
              id: Math.round(Math.random() * 10000000),
              messageType: "danger",
              text: error.response.data.message,
              headline: "Unable to Re-Order",
              delay: 5000, // ms
              icon: "",
              cssClass: "",
            } as FlashMessage;
            flashMessageStore.addMessage(message);
        }
        addingRecentOrder.value = null;
        loading.value = false;
      });
    } else {
      closeRecentOrderModal();
      addingRecentOrder.value = null;
      loading.value = false;
    }
  })

  const editRecentOrder = ((order: OrderDetail) => {
    loading.value = true;
    basketStore.editOrder(order.id).then(() => {
      loading.value = false;
      basketStore.editing = true;
      toggleUpcomingOrdersCollapse();
      const message = {
        id: Math.round(Math.random() * 10000000),
        messageType: "success",
        text: "You are now editing an upcoming order. You must place this new order or the original order will still be prepared and charged.",
        headline: "",
        delay: 5000, // ms
        icon: "",
        cssClass: "",
      } as FlashMessage;
      flashMessageStore.addMessage(message);
      router.push('/menu').then(() => {
        window.setTimeout(() => {
          closeRecentOrderModal();
          modalEditUnderstandOpen.value = true;
        }, 500);
      });
    }).catch((error) => {
      loading.value = false;
      closeRecentOrderModal();
      if (error.response && error.response.data && error.response.data.message) {
        const message = {
            id: Math.round(Math.random() * 10000000),
            messageType: "danger",
            text: error.response.data.message,
            headline: "Unable to Edit Order",
            delay: 5000, // ms
            icon: "",
            cssClass: "",
          } as FlashMessage;
          flashMessageStore.addMessage(message);
      }
    });
  })

  const cancelRecentOrder = ((order: OrderDetail) => {
    loading.value = true;
    basketStore.cancelOrder(order.id).then(() => {
      loading.value = false;
      closeRecentOrderModal();
      const message = {
        id: Math.round(Date.now() / 1000),
        messageType: "success",
        text: "Your order has been canceled.",
        headline: "Order Updated",
        delay: 0, // ms
        icon: "",
        cssClass: "",
      } as FlashMessage;
      flashMessageStore.addMessage(message);
    }).catch((error) => {
      loading.value = false;
      closeRecentOrderModal();
      if (error.message) {
        const message = {
            id: Math.round(Math.random() * 10000000),
            messageType: "danger",
            text: error.message,
            headline: "Unable to Cancel Order",
            delay: 5000, // ms
            icon: "",
            cssClass: "",
          } as FlashMessage;
          flashMessageStore.addMessage(message);
      }
    });
  })

  const showEditingOrderAlert = computed(() => {
    return basketStore.editing
  })

  const editCutoffTime = computed(() => {
    return basketStore.editOrderCutoffTime
  })
</script>